export default __webpack_public_path__ + "static/heroSection-27d544a5423f5c7d021a67e02100f099.mp4";